module.exports = __webpack_public_path__ + "static/media/The-West-Subscription-Black-Friday.ca5221d7.webp";